import React from 'react';
import clsx from 'clsx';

import {Typography} from '@nur-portal/ui-kit';

import {getRuUrl} from './helpers';
import {WidgetNominant} from './widget-nominant';

import styles from './widget-card.module.css';

export default ({
  slug,
  title,
  candidates,
  isActive,
  isStatic = false,
  category
}) => {
  const renderDivider = () => (
    <div className={styles.divider}>
      {Array.from({length: 19}, (v, i) => i).map(value => <span className={styles.dot} key={value} />)}
    </div>
  );

  return (
    <a
      href={`${getRuUrl}/golos-naroda/${category?.slug}/${slug}/`}
      className={clsx(styles.container, {[styles.active]: isActive, [styles.isStatic]: isStatic})}
    >
      <Typography
        variant='title-12'
        className={styles.title}
        component='p'
      >
        {title}
      </Typography>
      <>
        {candidates.map((candidate, index) => (
          <>
            {index === 3 && renderDivider()}
            <WidgetNominant
              key={candidate._id}
              currentPlace={index !== 3 ? index + 1 : candidate.place}
              {...candidate}
              isLast={index === 3}
            />
          </>
        ))}
      </>
    </a>
  );
};
